module.exports = __webpack_public_path__ + "static/media/loading-gif.6dcb1a63.gif";